/* eslint-disable no-undef, strict, no-console, no-unused-vars, eqeqeq */
/* global STORE */

// track oubound links and forms with GA event tracking
function trackOutboundForm(this_form, category, action, label) {
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'trackEvent',
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label,
				'eventValue': 'value',
				'eventProperty': 'property'
			});
		}
		if (typeof ga !== 'undefined') {
			ga('send', 'event', category, action, label);
		}
		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', category, action, label]);
		}
	} catch (err) {
		//do nothing
	}
	setTimeout(function () {
		this_form.submit();
	}, 300);
}

function trackOutboundLink(link, category, action, label) {
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'trackEvent',
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label,
				'eventValue': 'value',
				'eventProperty': 'property'
			});
		}
		if (typeof ga !== 'undefined') {
			ga('send', 'event', category, action, label);
		}
		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', category, action, label]);
		}
	} catch (err) {
		//do nothing
	}
	setTimeout(function () {
		document.location.href = link.href;
	}, 300);
}

function trackExternalLink(link, category, action, label) {
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'trackEvent',
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label,
				'eventValue': 'value',
				'eventProperty': 'property'
			});
		}
		if (typeof ga !== 'undefined') {
			ga('send', 'event', category, action, label);
		}
		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', category, action, label]);
		}
	} catch (err) {
		//do nothing
	}
	setTimeout(() => {
		window.open(link.href, '_blank').focus();
	}, 300);
}

function trackEvent(category, action, label) {
	console.log('trackEvent %o %o %o', category, action, label);
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'trackEvent',
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label,
				'eventValue': 'value',
				'eventProperty': 'property'
			});
		}
		if (typeof ga !== 'undefined') {
			ga('send', 'event', category, action, label);
		}
		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackEvent', category, action, label]);
		}
	} catch (err) {
		//do nothing
	}
}

function trackVirtualpage(pageurl, pagetitle) {
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push({
				'event': 'trackVirtualpage',
				'virtualPageURL': pageurl,
				'virtualPagetitle': pagetitle
			});
		}
		if (typeof ga !== 'undefined') {
			ga('send', 'pageview', pageurl, pagetitle);
		}
		if (typeof _gaq !== 'undefined') {
			_gaq.push(['_trackPageview', pageurl, pagetitle]);
		}
	} catch (err) {
		//do nothing
	}
}

function dataLayerPush(obj) {
	console.log('dataLayerPush %o', obj);
	try {
		if (typeof dataLayer !== 'undefined') {
			dataLayer.push(obj);
		}
	} catch (err) {
		//do nothing
	}
}

function scrollToAnchor(id, top) {
	try {
		history.scrollRestoration = 'manual';
	} catch (e) {
		console.warn(e);
	}
	try {
		if (!top) {
			top = $('#main_menu').outerHeight();
		}
		$('html,body').animate({scrollTop: id.offset().top - top}, 'slow');
	} catch (e) {
		console.warn(e);
	}
}


function createCookie(name, value, days) {
	var expires;

	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toGMTString();
	} else {
		expires = '';
	}
	document.cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value) + expires + '; path=/';
}

function readCookie(name) {
	var nameEQ = encodeURIComponent(name) + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
	}

	return null;
}

function eraseCookie(name) {
	createCookie(name, '', -1);
}

function toggle_input_type(input, new_type) {
	new_type = new_type || 'text';
	input.blur();
	var old_type = input.attr('data-old_type');
	var type = input.attr('type');

	if (typeof old_type === 'undefined') {
		old_type = new_type;
	}

	input.attr({'type': old_type});
	input.attr({'data-old_type': type});
	setTimeout(function () {
		input.trigger('focus');
		input[0].selectionStart = input[0].selectionEnd = input.val().length;
	}, 0);
}

$(function () {
	$('.modal-submit-timer').on('show.bs.modal', function () {
		var submit_timer;
		var remaining_seconds = 3;
		var submit = $(this).find('[type=submit]');
		var initial_text = $(this).find('[type=submit]')
			.html();
		submit.attr({disabled: true}).html(remaining_seconds);

		submit_timer = setInterval(function () {
			submit.html(remaining_seconds);
			if (remaining_seconds == 0) {
				submit.attr({disabled: false}).html(initial_text);

				clearInterval(submit_timer);
			}

			remaining_seconds--;
		}, 1000);
	});

	if (document.querySelectorAll('[data-toggle=tooltip]')?.length) {
		$('body').tooltip({selector: '[data-toggle=tooltip]'});
	}

	$('.rp_trigger').on('mouseenter mouseleave touchstart touchend', function (e) {
		var holder = $(this).closest('.rp_holder');
		switch (e.type) {
			case 'touchstart':
			case 'mouseenter':
				$('.rp_password', holder).removeClass('hidden');
				$('.rp_mask', holder).addClass('hidden');
				break;

			case 'touchend':
			case 'mouseleave':
				$('.rp_password', holder).addClass('hidden');
				$('.rp_mask', holder).removeClass('hidden');
				break;

			default:
		}
	});
	var show_passwords = document.querySelectorAll('.toggle-password');
	if (show_passwords) {
		for (var i = 0; i < show_passwords.length; i++) {
			var current_element = show_passwords[i];
			current_element.addEventListener('click', function () {
				var use = this.querySelector('svg use');
				var password_input = this.parentElement.parentElement.parentElement.querySelector('input');
				if (use.href.baseVal === '#svg_password-show') {
					use.href.baseVal = '#svg_password-hide';
					password_input.type = 'password';
				} else {
					use.href.baseVal = '#svg_password-show';
					password_input.type = 'text';
				}
			});
		}
	}
});

$(document).on('click touch', '.activity_more a', function () {
	var status = $(this).attr('data-status');

	if (status == 'opened') {
		$(this).attr({'data-status': 'closed'});
		$(this).closest('tbody')
			.children('tr')
			.not('.no_close')
			.addClass('none');
		$(this).html(messages.ACTIVITY_MORE + ' »');
	} else {
		$(this).attr({'data-status': 'opened'});
		$(this).closest('tbody')
			.children('tr')
			.not('.no_close')
			.removeClass('none');
		$(this).html(messages.ACTIVITY_LESS + ' »');
	}

	return false;
});

$(document).on('click touch', '.confirm, .btn-confirm', function () {
	var message = $(this).attr('data-confirm_message');
	if (!message)
		message = it('ARE_YOU_SURE');

	return confirm(message) ? true : false;
});

$(document).on('input', '.numbers-only', function () {
	this.value = this.value.replace(/[^0-9]/g, '');
});

$(document).on('change', '.table_filter select', function (e) {
	var target = $(this).val();
	var table = $(this).attr('data-table');
	var filter_name = $(this).attr('data-filter_name');
	var parent = $(this).closest('.table_filter');
	var all_filters = '';
	if (parent) {
		parent.find('select').each(function (index, select) {
			if ($(select).attr('data-filter_name') && $(select).val()) {
				all_filters += '[data-' + $(select).attr('data-filter_name') + '~="' + $(select).val() + '"]';
			}
		});
	} else {
		all_filters = '[data-' + filter_name + '~="' + target + '"]';
	}

	if (typeof filter_name === 'undefined')
		filter_name = 'filter';

	if (all_filters === '') {
		$(table).find('tbody tr')
			.removeClass('hidden even odd');
	} else {
		$(table).find('tbody tr')
			.addClass('hidden')
			.removeClass('even odd');
		$(table).find('tbody tr')
			.filter(function () {
				var show_me = false;
				if ($(this).is(all_filters)) {
					show_me = true;
				}

				return show_me;
			})
			.removeClass('hidden');
		$(table)
			.find('tbody tr:visible:even')
			.addClass('even');
		$(table)
			.find('tbody tr:visible:odd')
			.addClass('odd');
	}
});

// start/stop animations based on tab visibility
var hidden, visibility_change;
if (typeof document.hidden !== 'undefined') {
	hidden = 'hidden';
	visibility_change = 'visibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
	hidden = 'mozHidden';
	visibility_change = 'mozvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibility_change = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibility_change = 'webkitvisibilitychange';
}

function format_date(date) {
	var year = date.getFullYear();
	var month = date.getMonth() + 1;
	var day = date.getDate();

	month = month < 10 ? '0' + month : month;
	day = day < 10 ? '0' + day : day;

	return month + '/' + day + '/' + year;
}

function format_time(date) {
	var hours = date.getHours();
	var minutes = date.getMinutes();
	var seconds = date.getSeconds();

	hours = hours < 10 ? '0' + hours : hours;
	minutes = minutes < 10 ? '0' + minutes : minutes;
	seconds = seconds < 10 ? '0' + seconds : seconds;

	return hours + ':' + minutes + ':' + seconds;
}

function format_datetime(date) {
	var _format_date = format_date(date);
	var _format_time = format_time(date);

	return _format_date + ' ' + _format_time;
}

// start/stop animations based on tab visibility
if (typeof document.hidden !== 'undefined') {
	hidden = 'hidden';
	visibility_change = 'visibilitychange';
} else if (typeof document.mozHidden !== 'undefined') {
	hidden = 'mozHidden';
	visibility_change = 'mozvisibilitychange';
} else if (typeof document.msHidden !== 'undefined') {
	hidden = 'msHidden';
	visibility_change = 'msvisibilitychange';
} else if (typeof document.webkitHidden !== 'undefined') {
	hidden = 'webkitHidden';
	visibility_change = 'webkitvisibilitychange';
}

function handle_visibility_change() {
	if (document[hidden]) {
		$('#picture_holder').removeClass('animate');
		if (slider)
			slider.carousel('pause');
	} else {
		$('#picture_holder').addClass('animate');
		if (slider)
			slider.carousel('cycle');
	}
}

//document.addEventListener(visibility_change, handle_visibility_change, false);

function format_money(value, currency, cents, rate_precision) {
	return format_money_str(':symbol:integer:point:decimals:minor_symbol:code', value, currency, cents, rate_precision);
}

function format_money_str(format_string, value, _currency, cents, _rate_precision) {
	var currency = _currency || STORE.currency;
	var rate_precision = _rate_precision || STORE.rate_precision;

	if (!cents) {
		cents = false;
	}

	if (!rate_precision) {
		rate_precision = currency.exponent ? currency.exponent : 2;
	}

	value = Math.round(parseFloat(value) * Math.pow(10, rate_precision)) / Math.pow(10, rate_precision);

	var number_parts = (value + '').split('.');

	var components = {
		'code': '',
		'symbol': '',
		'minor_symbol': '',
		'integer': number_parts[0],
		'point': number_parts[1] ? '.' : '',
		'decimals': number_parts[1] ? number_parts[1] : ''
	};

	if (cents) {
		if (currency['minor_symbol'] && !STORE.hide_currency_symbol) {
			components['minor_symbol'] = currency['minor_symbol'];
		} else {
			return format_money_str(format_string, value / 100, currency, false, rate_precision);
		}
	} else {
		if (currency['symbol'] && !STORE.hide_currency_symbol) {
			if (components['integer'][0] === '-' && currency['symbol'].length >= 1 && currency['symbol'].length <= 2) {
				components['symbol'] = '-' + currency['symbol'];
				components['integer'] = components['integer'].substr(1);
			} else {
				components['symbol'] = currency['symbol'] + (currency['symbol'].length > 2 ? ' ' : '');
			}

		} else {
			components['code'] = ' ' + currency['code'];
		}
	}

	return format_string.replace(/:(\w+)/g, function (match, contents, offset, s) {
		return typeof components[contents] !== 'undefined' ? components[contents] : '';
	});
}

function format_megabyte(value, force_giga, force_mega) {
	if (typeof force_giga === 'undefined')
		force_giga = false;

	if (typeof force_mega === 'undefined')
		force_mega = false;

	return format_megabyte_str(':integer:point:decimals :code', value, force_giga, force_mega);
}

function format_megabyte_str(format_string, value, force_giga, force_mega) {
	var code;
	var components;
	var number_parts;
	var precision = 2;
	value = parseFloat(value);

	if (typeof force_giga === 'undefined')
		force_giga = false;

	if (typeof force_mega === 'undefined')
		force_mega = false;

	if (value < 1000) {
		if (force_giga) {
			value = value / 1024;
			value = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
			code = 'GB';
		} else {
			value = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
			code = 'MB';
		}
	} else {
		if (force_mega) {
			value = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
			code = 'MB';
		} else {
			value = value / 1024;
			value = Math.round(value * Math.pow(10, precision)) / Math.pow(10, precision);
			code = 'GB';
		}
	}

	number_parts = (value + '').split('.');
	components = {
		'integer': number_parts[0],
		'point': number_parts[1] ? '.' : '',
		'decimals': number_parts[1] ? number_parts[1] : '',
		'code': code
	};

	for (let key in components) {
		if (Object.prototype.hasOwnProperty.call(components, key)) {
			format_string = format_string.replace(':' + key, components[key]);
		}
	}

	return format_string;
}

function check_attribute(element, attribute) {
	var test = document.createElement(element);
	if (attribute in test)
		return true;

	return false;
}

// webcall popup window
function open_webcall(link_params) {
	if (!link_params)
		link_params = {};

	popitup(url('/account/webcall', link_params), 'Web Call', 'width=373,height=645,scrollbars=no');

	return false;
}

function popitup(url, name, properties) {
	if (!name)
		name = 'default_popup';
	if (!properties)
		properties = '';
	newwindow = window.open(url, name, properties);
	if (window.focus)
		newwindow.trigger('focus');

	return false;
}

function hide_page_message(page_message) {
	page_message.style.opacity = '0';
	setTimeout(() => {
		page_message.remove();
	}, 500);
}

function show_page_message(message, class_name = '', duration = 10000) {
	const page_message_holder = document.getElementById('page_message_holder');
	if (page_message_holder && message) {
		const page_message = document.createElement('div');
		page_message.classList.add('page_message');
		if (class_name !== '') {
			page_message.classList.add(class_name);
		}

		const message_wrapper = document.createElement('div');
		message_wrapper.classList.add('message_wrapper');

		const message_close = document.createElement('button');
		message_close.type = 'button';
		message_close.innerText = '×';
		message_close.addEventListener('click', () => {
			hide_page_message(page_message);
		});

		page_message.appendChild(message_wrapper);
		page_message.appendChild(message_close);
		page_message_holder.appendChild(page_message);

		let message_content = '';
		if (typeof message === 'object') {
			if (Array.isArray(message)) {
				for (let i = 0; i < message.length; i++) {
					const _message = message[i];
					message_content += `${_message}<br>`;
				}
			} else {
				for (const [key, value] of Object.entries(message)) {
					message_content += `${value}<br>`;
				}
			}
		} else {
			message_content += message;
		}
		message_wrapper.innerHTML = message_content;

		setTimeout(() => {
			page_message.style.opacity = '1';

			if (duration) {
				setTimeout(() => {
					hide_page_message(page_message);
				}, duration);
			}
		}, 50);
	}
}

var is_iOS = navigator.userAgent.match(/(iPad|iPhone|iPod)/g) ? true : false;
var is_Android = navigator.userAgent.match(/(Android)/g) ? true : false;
var is_iOSwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*(Version|CriOS|FxiOS))/i.test(navigator.userAgent);

var flag_regex = /(android|macintosh|windows|iphone).+safari/gi;
var flag_regex1 = /(windows|android).+chrome/gi;
const flag_fix = flag_regex.test(navigator.userAgent) && !flag_regex1.test(navigator.userAgent);

var slider = null;
var frontpage_slider = function () {
	var _slider = $('#frontpage_slider')
		.carousel({loop: true})
		.bind('slid', function (event, toIndex) {
			console.log(event, toIndex);
			$('#carousel-content-holder .item')
				.removeClass('active');
			$('#carousel-content-holder .item').eq(toIndex)
				.addClass('active');
		})
		.bind('slide', function (event, fromIndex, toIndex) {
			$('#carousel-nav > li, #carousel_progress > li').removeClass('active');
			$('#carousel_progress > li:nth-child(' + (toIndex + 1) + ')').addClass('active');
			$('#carousel-nav > li:nth-child(' + (toIndex + 1) + ')').addClass('active');
		})
	;
	var slider_clicked = false;
	$('#frontpage_slider .carousel-inner .item').on('hover',
		function () {
			_slider.carousel('pause');
		},
		function () {
			slider_clicked ? '' : _slider.carousel('cycle');
		}
	);

	$('.carousel_left').on('click', function () {
		_slider.carousel('prev');
	});
	$('.carousel_right').on('click', function () {
		_slider.carousel('next');
	});

	$('#carousel-nav > li').on('click', function () {
		slider_clicked = true;
		_slider.carousel($('#carousel-nav > li').index($(this)));
	})
		.on('hover',
			function () {
				_slider.carousel('pause');
			},
			function () {
				slider_clicked ? '' : _slider.carousel('cycle');
			}
		);
	$('#carousel_progress > li').on('click', function () {
		_slider.carousel($('#carousel_progress > li').index($(this)));
	})
		.on('hover',
			function () {
				_slider.carousel('pause');
			},
			function () {
				slider_clicked ? '' : _slider.carousel('cycle');
			}
		);

	return _slider;
};

var banner_timer_animation;
var banner_animation_cycle = 3000;

function repeat_banner() {
	$.each($('.messages_holder'), function (i, container) {
		var holder = $(container).find('.message_holder');
		if (holder.length > 1) {
			var active_banner = $('.message_holder.active').index();
			active_banner++;
			active_banner = active_banner % holder.length;
			holder.addClass('none')
				.removeClass('active');
			$(container).find('.message_holder:nth-child(' + (active_banner + 1) + ')')
				.removeClass('none')
				.addClass('active');

			banner_timer_animation = setTimeout(function () {
				repeat_banner();
			}, banner_animation_cycle);
		}
	});
}

// ---> TO BE DELETED! <---
function image_prefetch(image_url) {
	image_url = url(image_url);
	var new_image = document.createElement('img');
	new_image.setAttribute('src', image_url);

	return image_url;
}

$(function () {
	// Disable submit button on the id's first. Needs testing before activation on all forms.
	$('#buy_form, #account_login_form, #recover_password, #form_buy_payg').on('submit', function () {
		$(this)
			.find('button[type=submit]:not([name])')
			.prop({'disabled': true});
	});

	$('.dropdown-menu a').on('click touch', function (e) {
		e.stopPropagation();
	});

	/* ADD main menu logic */

	$('.collapse').on('show.bs.collapse', function () {
		var trigger = $('[data-target="#' + $(this).attr('id') + '"], div[href="#' + $(this).attr('id') + '"]');
		trigger.addClass('opened');
		$('.glyphicon-chevron-down', trigger).removeClass('glyphicon-chevron-down')
			.addClass('glyphicon-chevron-up');

		if ($('body').hasClass('account_home')) {
			var $next = trigger.closest('div').find('.plan_actions_info');
			$next.removeClass('opacity0');
			setTimeout(function () {
				$next.addClass('opacity0');
			}, 1000);
		}
	});

	$('.collapse').on('hide.bs.collapse', function () {
		var trigger = $('[data-target="#' + $(this).attr('id') + '"], div[href="#' + $(this).attr('id') + '"]');
		trigger.removeClass('opened');
		$('.glyphicon-chevron-up', trigger).removeClass('glyphicon-chevron-up')
			.addClass('glyphicon-chevron-down');
	});

	$('.btn-on_off > .btn').on('click', function () {
		var btn = $(this);
		var on_off_value_holder = $(this).closest('.on_off_settings_holder')
			.find('.btn-on_off_value');
		var on_of_value = on_off_value_holder.val();

		if ($(this).attr('data-on_off') == 'off') {
			$.each(on_off_value_holder.find('option'), function (i, option) {
				if ($(option).attr('value') == '' || $(option).attr('value') == 0) {
					on_off_value_holder.val($(option).attr('value'));

					return false;
				}

				return true;
			});
		}

		if ($(this).attr('data-on_off') == 'on' && (on_of_value == 0 || on_of_value == '')) {
			$.each(on_off_value_holder.find('option'), function (i, option) {
				if ($(option).attr('value') != '' && $(option).attr('value') != 0) {
					on_off_value_holder.val($(option).attr('value'));

					return false;
				}

				return true;
			});
		}
	});

	$('.btn-on_off_value').on('change', function () {
		var value = $(this).val();
		var on_off_holder = $(this).closest('.on_off_settings_holder')
			.find('.btn-on_off');

		if (value != '' && value != 0) {
			on_off_holder.find('label[data-on_off="on"]').click();
		} else {
			on_off_holder.find('label[data-on_off="off"]').click();
		}
	});
	$('.multiple_submit_track_event button').on('click', function () {
		var form = $(this).closest('form');
		form.find('input[name=btn_action]').attr('name', $(this).attr('data-name'));
		form.submit();

		return false;
	});
	$('.messages_holder .message_holder').on('hover',
		function () {
			clearTimeout(banner_timer_animation);
		},
		function () {
			banner_timer_animation = setTimeout(function () {
				repeat_banner();
			}, banner_animation_cycle);
		}
	);

	banner_timer_animation = setTimeout(function () {
		repeat_banner();
	}, banner_animation_cycle);

	if (flag_fix)
		$('body').addClass('flag_fix');
	else
		$('body').removeClass('flag_fix');

	$('.log_in_menu').on('click', function (e) {
		e.stopPropagation();
	});

	$('.phone_htc_selector').on('change', function () {
		window.location.href = $(this).val();
	});

	$('.phone_htc_local_selector').on('change', function () {
		$('.htc_selector a[href="' + $(this).val() + '"]').click();
	});

	$('.htc_selector a').on('click', function () {
		$('.phone_htc_local_selector option[value="' + $(this).attr('href') + '"]').prop('selected', true);
		$('.htc_selector a[href="' + $(this).val() + '"]').click();
	});

	$(document).off('click', 'table.row_checkbox tr')
		.on('click', 'table.row_checkbox tr', function () {
			$(this)
				.find('input[type=radio], input[type=checkbox]')
				.prop('checked', true);
		});

	function test_input_type(type) {
		var test = document.createElement('input');
		test.setAttribute('type', type);

		return test.type == type;
	}

	$.support.input_type = {
		'color': false,
		'date': false,
		'datetime': false,
		'datetime-local': false,
		'email': false,
		'month': false,
		'number': false,
		'range': false,
		'search': false,
		'tel': false,
		'time': false,
		'url': false,
		'week': false
	};


	$.each($.support.input_type, function (type) {
		var result = test_input_type(type);
		$.support.input_type[type] = result;
	});

	$.support.placeholder = $.support.placeholder || false;
	const test = document.createElement('input');

	if ('placeholder' in test)
		$.support.placeholder = true;

	if (!$.support.placeholder) {
		var active = document.activeElement;
		$(document).off('focus', 'input:not([type=hidden]), textarea')
			.on('focus', 'input:not([type=hidden]), textarea', function () {
				if ($(this).attr('placeholder') != '' && ($(this).val() == $(this).attr('placeholder') || $(this).val() == '******')) {
					$(this).val('')
						.removeClass('hasPlaceholder');
				}
			})
			.off('blur', 'input:not([type=hidden]), textarea')
			.on('blur', 'input:not([type=hidden]), textarea', function () {
				if ($(this).attr('placeholder') != '' && ($(this).val() == '' || $(this).val() == $(this).attr('placeholder'))) {
					var input_type = $(this).attr('type') || 'textarea';
					if (input_type == 'password')
						$(this).val('******')
							.addClass('hasPlaceholder');
					else
						$(this).val($(this).attr('placeholder'))
							.addClass('hasPlaceholder');
				}
			});
		$('input, textarea').blur();
		$(active).trigger('focus');
		$('form').on('submit', function () {
			$('input.hasPlaceholder, textarea.hasPlaceholder').val('');
		});
	}

	$('#referral_trigger').on('click', function () {
		var referral_tooltip = $(this).parent()
			.addClass('none')
			.next()
			.removeClass('none')
			.find('.referral_info');
		referral_tooltip.tooltip({
			title: referral_tooltip.attr('data-message'),
			placement: referral_tooltip.attr('data-dir')
		});

		return false;
	});

	// add more friends to TYP mass spam
	$('#add_friend').on('click', function () {
		var friends = $('#email_friends').children('li')
			.length;
		if (friends < 5) {
			var new_friend = $('#i_referral').closest('li')
				.clone();
			new_friend.find('input').removeAttr('id')
				.val('');
			$('#email_friends').append(new_friend);
			$('#email_friends li:last input').trigger('focus');
		}
		if (friends == 4)
			$(this).remove();

		return false;
	});

	// either this or the one below... depends on what they decide
	$('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle').on('hover',
		function () {
			var i = $(this).not('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle.active, .accordion.styled_acc > ' +
				' .accordion-group > .accordion-heading .accordion-toggle.inactive')
				.children('span[class*="bigicon-"]');
			if (i.length != 0) {
				var new_class = i.attr('class').replace('_inactive', '_active');
				i.attr('class', new_class);
			}
		},
		function () {
			var i = $(this).not('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle.active,'
				+ '.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle.inactive')
				.children('span[class*="bigicon-"]');
			if (i.length != 0) {
				var new_class = i.attr('class').replace('_active', '_inactive');
				i.attr('class', new_class);
			}
		}
	);
	$('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle').on('click', function () {
		$('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle').removeClass('active');
		$('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle span').each(function (index, value) {
			var new_class = $(value).attr('class');
			new_class = new_class.replace('_active', '_inactive');
			$(value).attr('class', new_class);
		});
		$(this).addClass('active');
		$('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle.active span[class*="bigicon-"]')
			.attr('class', $('.accordion.styled_acc > .accordion-group > .accordion-heading .accordion-toggle.active span[class*="bigicon-"]')
				.attr('class')
				.replace('_inactive', '_active'));
	});

	$('.account_nav_2 li').on('hover',
		function () {
			var i = $(this).not('.account_nav_2 li.active, .account_nav_2 li.inactive')
				.children('i');
			if (i.length != 0) {
				var new_class = i.attr('class')
					.replace('_inactive', '_active');
				i.attr('class', new_class);
			}
		},
		function () {
			var i = $(this).not('.account_nav_2 li.active, .account_nav_2 li.inactive')
				.children('i');
			if (i.length != 0) {
				var new_class = i.attr('class').replace('_active', '_inactive');
				i.attr('class', new_class);
			}
		}
	);
	$('.account_nav_2 li').on('click', function () {
		var tab_id = $(this).attr('tab-content');
		$('.account_nav_2 li').removeClass('active');
		$('.account_nav_2 li i').each(function (index, value) {
			var new_class = $(value).attr('class');
			new_class = new_class.replace('_active', '_inactive');
			$(value).attr('class', new_class);
		});
		$(this).addClass('active');
		$('.account_nav_2 li.active i').attr('class', $('.account_nav_2 li.active i').attr('class')
			.replace('_inactive', '_active'));
		$('.tab_content > div').removeClass('active');
		$('.tab_content > div#' + tab_id).addClass('active');
	});

	$('[rel=tooltip]:not(input)').tooltip();
	$('input[rel=tooltip]').tooltip({trigger: 'focus'});

	$('.faq_list .collapse').on('click', function (e) {
		e.stopPropagation();
	});

	$('#coupon').on('keypress', function (event) {
		if (event.keyCode == 13) {
			$('#add_coupon_button').click();
		}
	});

	//var all_states = all_states || {};
	// update the states when selecting the country
	$('#i_country')
		.on('change', function () {
			var country = $(this).val();
			var state_select = $('#i_state')[0];
			var old_state = $('#i_other_state').val();
			var states = false;
			const form = $(this).closest('form');

			if (country == '') {
				$('#i_other_state').addClass('hidden');
				$(state_select).addClass('hidden');
				if (form[0]) {
					form[0].dispatchEvent(new CustomEvent('changeCountry', {
						detail: {hasStateSelector: false, isCountryEmpty: true}
					}));
				}
			} else {
				try {
					states = all_states[country];
				} catch (e) {
					console.warn('Missing country array.');
				}
				state_select.selectedIndex = 0;
				state_select.options.length = 1;
				if (states) {
					state_select.options[0].text = country == 'US' ? messages.SELECT_STATE_CHECKOUT : messages.SELECT_REGION;
					for (var i = 0; i < states.length; i++) {
						state_select.options[i + 1] = new Option(states[i][1], states[i][0]);
						if (old_state == states[i][0])
							state_select.selectedIndex = i + 1;
					}
					$('#i_other_state').addClass('hidden');
					$(state_select).removeClass('hidden')
						.trigger('focus');

					if (form[0]) {
						form[0].dispatchEvent(new CustomEvent('changeCountry', {
							detail: {hasStateSelector: true, isCountryEmpty: false}
						}));
					}
				} else {
					$(state_select).addClass('hidden');
					$('#i_other_state').removeClass('hidden')
						.trigger('focus');

					if (form[0]) {
						form[0].dispatchEvent(new CustomEvent('changeCountry', {
							detail: {hasStateSelector: false, isCountryEmpty: false}
						}));
					}
				}
			}
		})
		.trigger('change')
	;
	$('.qanda_big_arrows li').on('click', function () {
		$('.qanda_big_arrows .active').removeClass('active');
		$(this).addClass('active');
		$('.faq_list .active').removeClass('active');
		$('.faq_list [data-catname=' + $(this).attr('data-catname') + ']').addClass('active');
	});
	$('.live_chat_popup').on('click', function () {
		popitup(url('/chat/prepare'), 'Chat', 'width=580,height=550,scrollbars=yes');

		return false;
	});
	$('.mobile_phone_nav, .phone_account_nav').on('change', function () {
		window.location.href = url($(this).val());
	});
	try {
		$('#currency_info').tooltip({title: messages.CURRENCY_INFO});
		$('#change_v3').tooltip({placement: 'bottom'});
	} catch (error) {
		console.log(error);
	}

	$('.change_recurring_charge_international_bundle_form').on('submit', function (e) {
		var postData = $(this).serializeArray();
		var formURL = $(this).attr('action');
		$.ajax({
			url: formURL,
			data: postData,
			success: function (data) {
				if (data) {
					show_page_message(it('CHANGES_SAVED_MESSAGE'), 'status_success');
				} else {
					show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
				}
			},
			error: function () {
				show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
			}
		});

		return false;
	});

	$('.change_recurring_charge_custom_plan_form').on('submit', function (e) {
		var postData = $(this).serializeArray();
		var formURL = $(this).attr('action');
		$.ajax({
			url: formURL,
			data: postData,
			success: function (data) {
				if (data) {
					show_page_message(it('CHANGES_SAVED_MESSAGE'), 'status_success');
				} else {
					show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
				}
			},
			error: function () {
				show_page_message(it('ERROR_TRY_AGAIN'), 'status_error');
			}
		});

		return false;
	});
	$('.change_recurring_charge_international_bundle_trigger').on('change', function (e) {
		$(this).submit();
	});
	$('.change_recurring_charge_custom_plan_trigger').on('change', function (e) {
		$(this).submit();
	});

	if (document.getElementById('form_register_new_account')) {
		const errorHandler = (input, errors, form, container) => {
			const parent = input.parentElement;
			if (errors) {
				if (parent.classList.contains('input-group')) {
					parent.insertAdjacentElement('afterend', container);
				} else if (input.getAttribute('name') === 'terms_and_conditions') {
					var parentElement = parent.parentNode;
					var label = parentElement.querySelector('label');
					label.insertAdjacentElement('afterend', container);
				} else {
					input.insertAdjacentElement('afterend', container);
				}
			}
		}
		const constraints = {
			first_name: {
				presence: {
					message: '^' + messages.ERROR_ENTER_FIRST_NAME
				}
			},
			last_name: {
				presence: {
					message: '^' + messages.ERROR_ENTER_LAST_NAME
				}
			},
			login: {
				presence: {
					message: '^' + messages.ERROR_PLEASE_ENTER_EMAIL
				},
				email: {
					message: '^' + messages.ERROR_INVALID_EMAIL
				}
			},
			password: {
				presence: {
					message: '^' + messages.ERROR_ENTER_PASSWORD
				},
				length: {
					minimum: STORE.password_security_meter_flag_usmvno ? 0 : 7,
					message: STORE.password_security_meter_flag_usmvno ? '' : '^' + messages.ERROR_PASSWORD_TOO_SHORT
				},
				passwordStrongSecurity: STORE.password_security_meter_flag_usmvno
			},
			confirm_password: {
				presence: {
					message: '^' + messages.ERROR_ENTER_PASSWORD_AGAIN
				},
				equality: {
					attribute: "password",
					message: '^' + messages.ERROR_PASSWORD_MISMATCH
				}
			},
			terms_and_conditions: {
				inclusion: {
					within: [true],
					message: "^" + messages.MANDATORY_FIELD
				}
			}
		};

		const validator = new FormValidator({
			errorHandler,
			isInvalid: 'inputError'
		});
		if (STORE.password_security_meter_flag_usmvno) {
			validator.passwordStrongSecurityMeter('form_register_new_account', 'password');
		}
		validator.start('form_register_new_account', constraints);
	}

	if (document.getElementById('alias_form')) {
		const aliasConstraints = {
			'nickname': {
				presence: true,
				requireonealpha: true,
			},
		}
		new FormValidator({isInvalid: 'inputError'}).start('alias_form', aliasConstraints);
	}

	$.validator.addMethod('username', function (value, element) {
		return this.optional(element) || /^[a-zA-Z0-9_.-]+$/.test(value);
	});
	$.validator.addMethod('phone', function (value, element) {
		return this.optional(element) || validate_phone_number(value)[0];
	});
	$.validator.addMethod('creditcard', function (value, element) {
		return this.optional(element) || validate_credit_card(value);
	});
	$.validator.addMethod('us_zip', function (value, element) {
		return this.optional(element) || validate_us_zip(value);
	}, jQuery.validator.format(messages.INVALID_ZIP_CODE));
	$.validator.addMethod('checkout_billing_zip', function (value, element) {
		if (element.closest('form').querySelector('[name="bill[country]"]')?.value === 'US') {
			return this.optional(element) || validate_us_zip(value);
		} else {
			return this.optional(element) || true;
		}
	}, jQuery.validator.format(messages.INVALID_ZIP_CODE));
	$.validator.addMethod('requireonealpha', function (value, element) {
		return this.optional(element) || /[a-z]+/i.test(value);
	}, jQuery.validator.format(messages.ERROR_MESSAGE_AT_LEAST_ONE_ALPHA));
});

function validate_us_zip(value) {
	return /^(\d{5})(?:\s*-\s*(\d{4}))?$/.test(value);
}

function get_form_security_fields() {
	const nothing_name = document.querySelector('form input[name^=_nothing_]')?.name;

	const security_fields = {
		_snowman: encodeURI('☃'),
		_token: document.querySelector('form input[name=_token]')?.value,
	};
	security_fields[nothing_name] = '';

	return security_fields;
}

function form_security_fields(original_uri, token_value, nothing_name) {
	var has_token = false;
	var has_nothing = false;
	var has_snowman = false;
	var security_fields = [];
	var uri = original_uri.split('&');

	uri.forEach(function (attributes) {
		attributes = attributes.split('=');
		if (attributes[0] === '_token' && decodeURIComponent(attributes[1]) === token_value) {
			has_token = true;
		}
		if (attributes[0] === nothing_name && attributes[1] === '') {
			has_nothing = true;
		}
		if (attributes[0] === '_snowman' && decodeURIComponent(attributes[1]) === '☃') {
			has_snowman = true;
		}
	});

	if (!has_token) {
		security_fields.push('_token=' + token_value);
	}
	if (!has_nothing) {
		security_fields.push(nothing_name + '=');
	}
	if (!has_snowman) {
		security_fields.push('_snowman=☃');
	}

	if (original_uri.length > 0) {
		original_uri += '&';
	}

	if (security_fields.length !== 0) {
		console.log('form_security_fields() adding needed fields');
		original_uri += encodeURI(security_fields.join('&'));
	}

	return original_uri;
}

/* settings ajaxSetup as default/fallbackup settings */
$.ajaxSetup({
	url: '/',
	type: 'post',
	dataType: 'json',
	data: {},
	beforeSend: function (jqXHR, settings) {
		if (settings.type === 'POST') {
			var token_value = $('form input[name=_token]').val();
			var nothing_name = $('form input[name^=_nothing_]').attr('name');

			settings.data = form_security_fields(settings.data, token_value, nothing_name);
		}
	},
	success: function (data, textStatus, jqXHR) {
		console.log(data, textStatus, jqXHR);
	},
	error: function (jqXHR, textStatus, errorThrown) {
		console.log(jqXHR, textStatus, errorThrown);
	}
});

if (!STORE.is_new_validator) {
	// form validation defaults
	$.validator.setDefaults({
		debug: false,
		errorClass: 'inputError',
		submitHandler: function (form) {
			$(':submit', form).attr({'disabled': true});
			form.submit();
		}
	});
}
// temporary fix
$.validator.setDefaults({
	debug: false,
	errorClass: 'inputError',
	submitHandler: function (form) {
		$(':submit', form).attr({'disabled': true});
		form.submit();
	}
});
(function ($) {
	$.fn.removeClassRegEx = function (regex) {
		var classes = $(this).attr('class');

		if (!classes || !regex)
			return false;

		var classArray = [];
		classes = classes.split(' ');

		for (var i = 0, len = classes.length; i < len; i++)
			if (!classes[i].match(regex))
				classArray.push(classes[i]);

		$(this).attr('class', classArray.join(' '));

		return $(this);
	};
})(jQuery);

(function ($) {
	$.fn.getCursorPosition = function () {
		var input = this.get(0);
		if (!input) return 0; // No (input) element found
		if ('selectionStart' in input) {
			// Standard-compliant browsers
			return input.selectionStart;
		} else if (document.selection) {
			// IE
			input.trigger('focus');
			var sel = document.selection.createRange();
			var selLen = document.selection.createRange().text.length;
			sel.moveStart('character', -input.value.length);

			return sel.text.length - selLen;
		}

		return 0;
	};
})(jQuery);

function validate_phone_number(phone) {
	var ext, match, us_re, intl_re, try_us = true, try_intl = true, valid = false;

	// disabled the validation for now:
	return [$.trim(phone) != '', phone];

	// phone = phone.replace(/[^0-9x+]/g, '');
	// if (phone) {
	// 	phone = phone.replace(/^\+?(011|00)/, '+');
	// 	match = /^(\+?[0-9]+)(x([0-9]+))?$/.exec(phone);
	// 	if (match && match[1].length >= 6 && match[1].length <= 16) {
	// 		phone = match[1];
	// 		ext = match[3];
	// 		us_re = /^([2-9][0-8][0-9])([2-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/;
	// 		// intl_re = /^\+?(2[07]|2[1-69][0-9]|3[0-469]|3[578][0-9]|4[013-9]|42[0-9]|5[09][0-9]|
	// 		//5[1-8]|6[0-6]|6[7-9][0-9]|7|8[1-46]|8[0578][0-9]|9[0-58]|9[679][0-9])(.*)$/;
	// 		match = /^\+?1(.*)/.exec(phone);
	// 		if (match) {
	// 			phone = match[1];
	// 			try_intl = false;
	// 		}
	// 		if (try_us) {
	// 			match = us_re.exec(phone);
	// 			if (match) {
	// 				phone = '+1 (' + match[1] + ') ' + match[2] + ' ' + match[3];
	// 				valid = true;
	// 			}
	// 		}
	// 		if (!valid && try_intl) {
	// 			match = intl_re.exec(phone);
	// 			if (match) {
	// 				phone = '+' + match[1] + ' ' + match[2];
	// 				valid = true;
	// 			}
	// 		}
	// 		if (valid) {
	// 			phone = phone + (ext ? ' x ' + ext : '');
	// 		}
	// 	}
	// }

	// return [valid, phone];
}


function validate_credit_card(number) {
	var formats = [
		['2[2-7]', 16],			// Mastercard
		['5[1-5]', 16],			// Mastercard
		['3[47]', 15],			// American Express
		['6011|64[4-9]|65', 16], // Discover
		['6011|64[4-9]|65', 19], // Discover
		['2131|1800|35', 16],	// JCB
		['4', 13],				// Visa
		['4', 16],				// Visa
		['4', 19]				// Visa
	];

	number = number.replace(/[^0-9]/g, '');

	var valid = false;
	for (var i = 0; i < formats.length; i++) {
		if (number.length == formats[i][1] && number.match(new RegExp('^(' + formats[i][0] + ')')))
			valid = true;
	}
	if (!valid)
		return false;

	// luhn check
	var parity = number.length % 2;
	var total = 0;
	for (i = 0; i < number.length; i++) {
		var digit = parseInt(number.charAt(i));
		if (i % 2 == parity) {
			digit *= 2;
			if (digit > 9)
				digit -= 9;
		}
		total += digit;
	}

	return total % 10 == 0;
}

function track_custom_plan(preselected_values) {
	var preselected_data = preselected_values ? preselected_values.mobile_data : null;
	var preselected_voice = preselected_values ? preselected_values.mobile_voice : null;
	var preselected_sms = preselected_values ? preselected_values.mobile_sms : null;

	$('#buy_form button[type="submit"]').on('click', function () {
		var selected_data = $('div[data-product_type=mobile_data] .swiper-slide.active').attr('data-amount');
		var selected_voice = $('div[data-product_type=mobile_voice] .swiper-slide.active').attr('data-amount');
		var selected_sms = $('div[data-product_type=mobile_sms] .swiper-slide.active').attr('data-amount');

		if (typeof selected_sms === 'undefined') {
			selected_sms = 'unlimited';
		}

		var action = '';
		var label = '';
		var fixed_values = [selected_data, selected_voice, selected_sms, preselected_data, preselected_voice, preselected_sms];
		var arr = jQuery.map(fixed_values, function (amount) {
			if (amount === null || amount === 'none') {
				return 0;
			}

			if (amount == 0 || typeof amount === 'string' && amount.toLowerCase() === 'unlimited') {
				return Infinity;
			}

			return parseInt(amount);
		});

		selected_data = arr[0];
		selected_voice = arr[1];
		selected_sms = arr[2];
		var _preselected_data = arr[3];
		var _preselected_voice = arr[4];
		var _preselected_sms = arr[5];

		if (_preselected_data === selected_data) {
			action += 'Equal Data';
			label += '';
		} else if (_preselected_data < selected_data) {
			action += 'Upgraded Data';
			label += 'DATA ' + _preselected_data + ' to ' + selected_data;
		} else if (_preselected_data > selected_data) {
			action += 'Downgraded Data';
			label += 'DATA ' + _preselected_data + ' to ' + selected_data;
		}

		if (_preselected_voice === selected_voice) {
			action += ' Equal Voice';
			label += '';
		} else if (_preselected_voice < selected_voice) {
			action += ' Upgraded Voice';
			label += ' VOICE ' + _preselected_voice + ' to ' + selected_voice;
		} else if (_preselected_voice > selected_voice) {
			action += ' Downgraded Voice';
			label += ' VOICE ' + _preselected_voice + ' to ' + selected_voice;
		}

		if (typeof $('div[data-product_type=mobile_sms] .swiper-slide.active').attr('data-amount') !== 'undefined') {
			if (_preselected_sms === selected_sms) {
				action += ' Equal SMS';
				label += '';
			} else if (_preselected_sms < selected_sms) {
				action += ' Upgraded SMS';
				label += ' SMS ' + _preselected_sms + ' to ' + selected_sms;
			} else if (_preselected_sms > selected_sms) {
				action += ' Downgraded SMS';
				label += ' SMS ' + _preselected_sms + ' to ' + selected_sms;
			}
		}

		trackEvent('Custom Plan Progression', $.trim(action), $.trim(label));
	});
}

var track_video_gtm = function () {
	if (typeof dataLayer !== 'undefined' || typeof ga !== 'undefined' || typeof _gaq !== 'undefined') {
		var gtmYTListeners = [];
		window.onYouTubeIframeAPIReady = function () {
			for (var e = document.getElementsByTagName('iframe'), x = e.length; x--;) {
				if (/youtube.com\/embed/.test(e[x].src)) {
					gtmYTListeners.push(new YT.Player(e[x], {
						events: {onStateChange: onPlayerStateChange}
					}));
					YT.gtmLastAction = 'p';
				}
			}
		};
		window.onPlayerStateChange = function (e) {
			e['data'] == YT.PlayerState.PLAYING && setTimeout(onPlayerPercent, 1000, e['target']);
		};
		window.onPlayerPercent = function (e) {
			if (e['getPlayerState']() == YT.PlayerState.PLAYING) {
				var t = e['getDuration']() - e['getCurrentTime']() <= 1.5 ? 1 : (Math.floor(e['getCurrentTime']() / e['getDuration']() * 4) / 4).toFixed(2);
				if (!e['lastP'] || t > e['lastP']) {
					var extra_data = e['getIframe']().getAttribute('data-video_label');
					var extra_info;
					if (extra_data) {
						extra_info = extra_data + ' - ';
					} else {
						extra_info = '';
					}
					var video_data = e['getVideoData'](),
						label = video_data.title;
					e['lastP'] = t;
					var action = '';
					if (t == 0) {
						action = 'Video Played';
					} else {
						action = t * 100 + '% Played';
					}
					if (typeof dataLayer !== 'undefined') {
						dataLayer.push({
							'event': 'trackEvent',
							'eventCategory': 'Youtube Videos',
							'eventAction': action,
							'eventLabel': extra_info + label
						});
					}
					if (typeof ga !== 'undefined') {
						ga('send', 'event', 'Youtube Videos', action, label);
					}
					if (typeof _gaq !== 'undefined') {
						_gaq.push(['_trackEvent', 'Youtube Videos', action, label]);
					}
				}
				e['lastP'] != 1 && setTimeout(onPlayerPercent, 1000, e);
			}
		};
		var j = document.createElement('script'),
			f = document.getElementsByTagName('script')[0];
		j.src = '//www.youtube.com/iframe_api';
		j.async = true;
		f.parentNode.insertBefore(j, f);
	}
};

var valid_email = function (address) {
	var regex_check = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

	return regex_check.test(address);
};

function remaining_timer(timer_holder) {
	var _current_date = new Date();
	var _start_date = new Date(timer_holder.attr('data-start_date_offer'));
	var _end_date = new Date(timer_holder.attr('data-end_date_offer'));

	var start_holder = timer_holder.find('._banner_timer_start');
	var end_holder = timer_holder.find('._banner_timer_end');

	if (_start_date && start_holder.length > 0) {
		var start_trigger = 259200;
		var diff_start = Math.floor((_start_date - _current_date) / 1000) + '';

		if (diff_start >= 0 && diff_start <= start_trigger) {
			start_holder.find('._timer').text(diff_start.toHMS());
			start_holder.removeClass('none');
		} else
			start_holder.addClass('none');
	}

	if (_end_date && end_holder.length > 0) {
		var end_trigger = 259200;
		var diff_end = Math.floor((_end_date - _current_date) / 1000) + '';

		if (diff_end >= 0 && diff_end <= end_trigger) {
			end_holder.find('._timer').text(diff_end.toHMS());
			end_holder.removeClass('none');
		} else
			end_holder.addClass('none');
	}

	if (_start_date && start_holder.length > 0 || _end_date && end_holder.length > 0) {
		setTimeout(function () {
			remaining_timer(timer_holder);
		}, 1000);
	}

}

// MVNO Stores Switch based on IP
/* eslint-disable consistent-return */
// $(window).on('load', function() {
// 	var checkMvnoStore = function() {
// 		var change_suggestion = '',
// 			switch_button = '',
// 			change_button = '',
// 			country_code = '';

// 		if (typeof STORE.geoip.country_code !== 'string')
// 			return false;

// 		switch (STORE.name.toLowerCase()) {
// 			case 'usmvno.keepcalling.net':
// 			case 'tello.com':
// 				country_code = 'US';
// 				if (STORE.geoip.country_code.toLowerCase() === 'gb') {
// 					change_suggestion = 'For UK based service please visit';
// 					change_button = {
// 						'text': 'tello.co.uk',
// 						'class': 'btn-green',
// 						'url': 'https://tello.co.uk'
// 					};
// 					switch_button += '<a href="' + change_button.url + '" class="continue_btn btn btn-' + change_button.class + ' btn-normal"' +
// 						' data-dismiss_trigger="continue_button">';
// 					switch_button += '<strong class="padding_horizontal20 text-lowercase font-size24">' + change_button.text + ' &raquo;</strong>';
// 					switch_button += '</a>';
// 				} else {
// 					change_suggestion = messages.SHOPPING_IN_US;
// 					change_button = {
// 						'text': messages.CONTINUE_TELLO,
// 						'class': 'btn-warning',
// 						'url': ''
// 					};
// 					switch_button += '<button type="button" class="continue_btn btn ';
// 					switch_button += change_button.class + ' btn-lg" data-dismiss_trigger="continue_button" data-dismiss="modal">';
// 					switch_button += change_button.text + '</button>';
// 				}
// 				break;

// 			case 'mvno.keepcalling.net':
// 			case 'tello.co.uk':
// 				country_code = 'UK';
// 				if (STORE.geoip.country_code.toLowerCase() === 'US') {
// 					change_suggestion = 'For US based service please visit';
// 					change_button = {
// 						'text': 'tello.com',
// 						'class': 'btn-green',
// 						'url': 'https://tello.com'
// 					};
// 					switch_button += '<a href="' + change_button.url + '" class="continue_btn btn btn-' + change_button.class + ' btn-normal"' +
// 						' data-dismiss_trigger="continue_button">';
// 					switch_button += '<strong class="padding_horizontal20 text-lowercase font-size24">' + change_button.text + ' &raquo;</strong>';
// 					switch_button += '</a>';
// 				} else {
// 					change_suggestion = 'Shopping in the UK?';
// 					change_button = {
// 						'text': 'CONTINUE',
// 						'class': 'btn-warning',
// 						'url': ''
// 					};
// 					switch_button += '<button type="button" class="continue_btn btn ';
// 					switch_button += change_button.class + ' btn-lg" data-dismiss_trigger="continue_button" data-dismiss="modal">';
// 					switch_button += change_button.text + '</button>';
// 				}
// 				break;

// 			default:
// 				break;
// 		}

// 		var modal = '';
// 		modal += '<div class="modal fade" id="changeStore" role="dialog" aria-labelledby="gridSystemModalLabel" data-keyboard="false" data-backdrop="static">';
// 		modal += '<div class="modal-dialog" role="document">';
// 		modal += '<div class="modal-content bg-grey_lighter padding_vertical20 padding_horizontal30">';
// 		modal += '<button type="button" class="close" data-dismiss="modal" aria-label="Close" data-dismiss_trigger="close_button">';
// 		modal += '<span aria-hidden="true">&times;</span>';
// 		modal += '</button>';
// 		modal += '<div class="row change_' + country_code.toLowerCase() + '_store_modal margin_bottom20 text-center">';
// 		modal += '<div class="col-sm-12 margin_top30 font-size18">';
// 		modal += it('YOUR_CURRENT_LOCATION', {'location_country': STORE.geoip.country_name});
// 		modal += '</div>';
// 		modal += '<div class="col-sm-offset-2 col-sm-8 col-sm-12 margin_vertical50 font-size24">';
// 		modal += it('SERVICE_TO_US_ONLY', {'site_name': STORE.name, 'country_code': country_code});
// 		modal += '</div>';
// 		modal += '<div class="col-sm-12 font-size24">';
// 		modal += '<strong>' + change_suggestion + '</strong>';
// 		modal += '</div>';
// 		modal += '<div class="col-sm-12 margin_top10">';
// 		modal += switch_button;
// 		modal += '</div>';
// 		modal += '</div>';
// 		modal += '</div>';
// 		modal += '</div>';
// 		modal += '</div>';

// 		if (STORE.geoip.country_code.toLowerCase() !== country_code.toLowerCase()) {
// 			$('body').append(modal);
// 			$('#changeStore').modal('show');
// 		}
// 	};

// 	if (!readCookie('enableMvnoSwitchModal')) {
// 		checkMvnoStore();
// 		$('#changeStore .close, #changeStore .continue_btn').on('click', function() {
// 			createCookie('enableMvnoSwitchModal', 'active', 30);
// 		});
// 	}
// });
function time_to_promo(element, text, time_until, server_time) {
	var countDownDate = new Date(time_until).getTime();
	// Get todays date and time
	var now = new Date(server_time).getTime();
	// Find the distance between now an the count down date
	var distance = countDownDate - now;
	// Update the count down every 1 second
	var x = setInterval(function () {

		distance -= 1000;
		// Time calculations for days, hours, minutes and seconds
		var days = Math.floor(distance / (1000 * 60 * 60 * 24));
		var hours = Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60));
		var minutes = Math.floor(distance % (1000 * 60 * 60) / (1000 * 60));


		// Display the result in the element with id="demo"
		document.getElementById(element).innerHTML = text + ' ' + days + 'd ' + hours + 'h '
			+ minutes + 'm';

		// If the count down is finished, write some text
		if (distance < 0) {
			clearInterval(x);
			// location.reload();
		}
	}, 1000);
}

function isInternetExplorer() {
	var ua = window.navigator.userAgent;
	var msie = ua.indexOf('MSIE ');
	var edge = ua.indexOf('Edge');

	return !!(msie > 0 || edge > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./));
}

function getSpinner() {
	if (isInternetExplorer()) {
		return '<img src="' + url('/images/spinner.gif') + '" class="height100 width100">';
	}

	return '<img src="' + url('/images/spinner.svg') + '" class="height100 width100">';
}

function is_element_in_viewport(el) {
	if (el.length < 1) {
		return false;
	}

	var rect = el[0].getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /*or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /*or $(window).width() */
	);
}

/* eslint-enable consistent-return */
/* general my account START */
$(function () {
	// maybe add a cancel trigger?
	$('.edit_form form').on('reset', function () {
		var edit_fields = $(this).closest('.edit_fields');
		edit_fields.find('.edit_initial').show();
		edit_fields.find('.edit_form').hide();
	});

	$('.edit_trigger', '.edit_fields').on('click', function () {
		var edit_fields = $(this).closest('.edit_fields');
		edit_fields.find('.edit_initial').hide();
		edit_fields.find('.edit_form').show();
	});

	try {
		const svg_common = new SvgCommon();
		$('#why_logo').append(svg_common.cloneContent('svg_logo', 'svg_logo_bg_blue'));
		$('.new_trust_pilot').append(svg_common.cloneContent('svg_trustpilot-logo', 'svg_trustpilot_white'));
	} catch (error) {
	}

	$(document)
		.find('.table_filter select')
		.each(function (index, value) {
			$(value).val('');
		})
	;
	if (!STORE.is_new_validator) {
		$.extend(jQuery.validator.messages, {
			required: it('MANDATORY_FIELD'),
			remote: it('ERROR_EMAIL_ADDRESS_ALREADY_IN_USE'),
			email: it('CONTACT_NO_MSG_ERR'),
			url: it('ERROR_VALID_URL'),
			date: it('ERROR_VALID_DATE'),
			number: it('ERROR_VALID_NUMBER'),
			phone: it('ERROR_VALID_NUMBER'),
			digits: it('ERROR_ENTER_DIGITS_ONLY'),
			creditcard: it('INVALID_CARD_NUMBER'),
			equalTo: it('ERROR_ENTER_EMAIL_ADDRESS_AGAIN'),
			rangelength: it('ERROR_ENTER_TEXT_BETWEEN'),
			maxlength: it('ERROR_ENTER_MAX_LENGTH'),
			minlength: it('ERROR_ENTER_MIN_LENGTH'),
			max: it('ERROR_ENTER_VALUE_LESS_EQUAL_TO'),
			min: it('ERROR_ENTER_VALUE_GREATER_EQUAL_TO'),
			range: it('ENTER_VALUE_CHARACTERS'),
		});
		$.extend(jQuery.validator.prototype, {
			focusInvalid: function () {
				if (this.settings.focusInvalid) {
					try {
						$(this.findLastActive() || this.errorList.length && this.errorList[0].element || [])
							.filter(':visible')
							.focus()
							// manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
							.trigger('focusin');
						first_invalid_element = $(this.findLastActive() || this.errorList.length && this.errorList[0].element || []);
						menu_height = $('#main_menu').outerHeight(true);
						if (first_invalid_element.offset().top - $(window).scrollTop() < 70) {
							$(window).scrollTop(first_invalid_element.offset().top - menu_height - 50);
						}
					} catch (e) {
						// ignore IE throwing errors when focusing hidden elements
					}
				}
			}
		});
	}
});
var account = {};
account.my_settings = (o) => {
	console.log('account.my_settings(%o)', o);
	if (o.mobile_credit) {
		$(document).on('click', '.modify_auto_recharge', function (e) {
			e.preventDefault();
			showAutoRechargeForm();
		});

		$(document).on('click', '.cancel_auto_recharge_form', function (e) {
			e.preventDefault();
			hideAutoRechargeForm();
		});
		$(document).on('change', '.btn-on_off_value', function () {
			var new_value = $('.btn-on_off_value option:selected').attr('value');
			var message_holder = $('.auto_recharge_text');
			if (parseInt(new_value) === 0) {
				message_holder.html(it('TELLO_MY_ACCOUNT_AUTO_TOP_UP_MESSAGE', {
					'min_amount': format_money(o.mobile_credit.ar_min_amount)
				}));
			} else {
				message_holder.html(it('TELLO_MY_ACCOUNT_AUTO_TOP_UP', {
					'selected_amount': format_money(new_value),
					'min_amount': format_money(o.mobile_credit.ar_min_amount)
				}));
			}
		});
	}

	$(function () {
		if (o.mobile_credit) {
			$('#auto_recharge_form .btn-on_off')
				.not('.parent-btn-on_off')
				.on('change', function (e) {
					e.preventDefault();
					e.stopPropagation();
					var _checked_radio = $(this).find('input:checked');
					var _amount_select = $('.btn-on_off_value');

					if (_checked_radio.val() === '1') {
						_amount_select.find('option').attr('selected', false);
					} else {
						_amount_select.find('option').attr('selected', false);
						_amount_select.find('option[value=10]').attr('selected', 'selected');
					}
				});

			$('#auto_recharge_form .btn-on_off > .btn').on('click', function (e) {
				e.preventDefault();
				var on_off_value_holder = $('.btn-on_off_value');
				var on_of_value = on_off_value_holder.val();

				if ($(this).attr('data-on_off') === 'off' && !$(this).hasClass('active')) {
					$.each(on_off_value_holder.find('option'), function (i, option) {
						if ($(option).attr('value') === '' || parseInt($(option).attr('value')) === 0) {
							on_off_value_holder.val($(option).attr('value'));

							return false;
						}

						return true;
					});
					$('#auto_recharge_form').submit();
					hideAutoRechargeForm();
				}
				if ($(this).attr('data-on_off') === 'on' && (parseInt(on_of_value) === 0 || on_of_value === '')) {
					$('.auto_recharge_text').append(getModifyLink());
					$.each(on_off_value_holder.find('option'), function (i, option) {
						if ($(option).attr('value') !== '' && parseInt($(option).attr('value')) !== 0) {
							on_off_value_holder.val($(option).attr('value'));

							return false;
						}

						return true;
					});
					showAutoRechargeForm();
				}
			});

			$('#change_data_usage .btn-on_off')
				.not('.parent-btn-on_off')
				.on('change', function () {
					$('#change_data_usage').submit();
				});
			$('#change_international_roaming_status_form .btn-on_off')
				.not('.parent-btn-on_off')
				.on('change', function () {
					$('#change_international_roaming_status_form').submit();
				});
			$('.save_auto_recharge_form').on('click', function (e) {
				e.preventDefault();
				$('#auto_recharge_form').submit();
			});
		}

		if (o.mobile_msisdn) {
			$('#text_settings .btn-on_off')
				.not('.parent-btn-on_off')
				.on('change', function () {
					$('#text_settings').submit();
				});
		}
	});

	function showAutoRechargeForm() {
		var _modify_button = $('.modify_auto_recharge');
		var _auto_holder = $('.auto_holder ');
		var _buttons = $('.auto_recharge_buttons');

		_modify_button.addClass('hidden');
		_auto_holder.removeClass('hidden');
		_buttons.removeClass('hidden');
		$('.btn-on_off_value').trigger('change');
	}

	function hideAutoRechargeForm() {
		var _modify_button = $('.modify_auto_recharge');
		var _auto_holder = $('.auto_holder ');
		var _autorecharge_texts = $('.auto_recharge_text');
		var _buttons = $('.auto_recharge_buttons');
		var on_off_value_holder = $('.btn-on_off_value');
		var original_value = $('.original_value').val();
		_auto_holder.addClass('hidden');
		_buttons.addClass('hidden');
		if (!original_value) {
			original_value = 10;
		}
		$.each(on_off_value_holder.find('option'), function (i, option) {
			if ($(option).val() == original_value) {
				on_off_value_holder.val($(option).attr('value'));
			}
		});
		on_off_value_holder.trigger('change');
		_autorecharge_texts.append(getModifyLink());
	}

	function getModifyLink() {
		var modify_link = document.createElement('a');
		modify_link.classList.add('modify_auto_recharge', 'font-size14', 'color_blue');
		modify_link.text = it('EDIT');
		modify_link.href = '#';

		return modify_link;
	}
};

/* general my account END */

function format_phone(phone) {
	var new_phone = phone.replace(/[^0-9]/gi, '', phone);
	var intl_re = /^\+?(2[07]|2[1-69][0-9]|3[0-469]|3[578][0-9]|4[013-9]|42[0-9]|5[09][0-9]|5[1-8]|6[0-6]|6[7-9][0-9]|7|8[1-46]|8[0578][0-9]|9[0-58]|9[679][0-9])(.*)$/;
	var matches_us = new_phone.match(/^\+?1([2-9][0-8][0-9])([2-9][0-9][0-9])([0-9][0-9][0-9][0-9])$/);
	var matches_intl = new_phone.match(intl_re);

	if (matches_us && matches_us.length > 2) {
		new_phone = '+1 (' + matches_us[1] + ') ' + matches_us[2] + ' ' + matches_us[3];
	} else if (matches_intl && matches_intl.length > 1) {
		new_phone = '+' + matches_intl[1] + ' ' + matches_intl[2];
	}

	return new_phone;
}

function cumulativeOffset(element) {
	var top = 0, left = 0;
	do {
		top += element.offsetTop || 0;
		left += element.offsetLeft || 0;
		element = element.offsetParent;
	} while (element);

	return {
		top: top,
		left: left
	};
}

function calculate_new_widget_height(element, relative_to) {
	var top_offset = cumulativeOffset(element).top;
	var relative_to__height = relative_to.offsetHeight;
	var real_top_offset = top_offset - relative_to__height - 485;

	return {
		holder_height: 475 + real_top_offset,
		answer_holder_height: 335 + real_top_offset,
		contact_holder_height: 475 - 30 + real_top_offset,
		offset_top: real_top_offset
	};
}

window.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.input-group .btn-copy')?.forEach(btn_copy => {
		const input_copy = btn_copy.closest('.input-group').querySelector('.input-copy');
		if (input_copy) {
			btn_copy.addEventListener('click', () => {
				try {
					input_copy.select();
					input_copy.setSelectionRange(0, input_copy.value.length);
					navigator.clipboard.writeText(input_copy.value).then(() => {
						input_copy.blur();
						const icon_holder = btn_copy.querySelector('.glyphicon');
						if (icon_holder) {
							icon_holder.classList.remove('glyphicon-duplicate');
							icon_holder.classList.add('glyphicon-ok');

							setTimeout(() => {
								icon_holder.classList.remove('glyphicon-ok');
								icon_holder.classList.add('glyphicon-duplicate');
							}, 3000);
						}
					})
				} catch (e) {
					console.error(e);
				}
			});
		}
	});

	(function () {
		function handleEnterKey(event) {
			if (event.key === 'Enter') {
				const inputElement = event.target;
				const targetSelector = inputElement.getAttribute('data-on-enter-click');
				if (targetSelector) {
					const targetElement = document.querySelector(targetSelector);
					if (targetElement && !targetElement.disabled) {
						event.preventDefault();
						targetElement.click();
					}
				}
			}
		}

		document.querySelectorAll('input[data-on-enter-click]').forEach(input => {
			input.addEventListener('keydown', handleEnterKey);
		});
	})();

	window.dispatchEvent(new Event('scroll', {
		bubbles: true,
		cancelable: false,
	}));

	if (global_message && (_page_name !== 'subscribe' || !('success' in global_message))) {
		show_page_message(global_message);
	}

	if (global_v3_success_message && _page_name !== 'subscribe') {
		show_page_message(global_v3_success_message, 'status_success');
	}

	if (global_v3_error_message) {
		show_page_message(global_v3_error_message, 'status_error');
	}

	if (global_v3_notice_message) {
		show_page_message(global_v3_notice_message, 'status_notice');
	}

	if (global_v3_warning_message) {
		show_page_message(global_v3_warning_message, 'status_warning');
	}

	if (!['help_center', 'account/checkout', 'chat/window', 'chat/prepare'].includes(_page_name)) {
		try {
			new HelpCenterWidget({page_name: _page_name});
		} catch (e) {
			console.error(e);
			const answer_holder = document.getElementById('answer_holder');
			if (answer_holder) {
				answer_holder.insertAdjacentHTML('beforeend', `<div class='padding15'><p>${it('SOCIAL_LOGIN_ERROR')}</p></div>`);
			}
		}
	}

	if (_url_is_ssl) {
		$('#form_newsletter, #footer_form_newsletter').on('submit', function () {
			var form = $(this);
			var email = form.find('input[name=email]').val();
			var _token = form.find('input[name=_token]').val();
			let messageHolder;
			if ('footer_form_newsletter' === form.attr('id')) {
				messageHolder = '#form_footer_newsletter_message';

			} else {
				messageHolder = '#form_newsletter_message';
			}
			$(messageHolder).addClass('hidden')
				.removeClass('alert alert-danger alert-success')
				.html('');

			if (email.length > 5) {
				form.find('.spinner').removeClass('hidden');
				$.ajax({
					url: url('/process_newsletter'),
					data: {
						email: email,
						_token: _token
					},
					success: function (response) {
						form.find('.spinner').addClass('hidden');
						if (response.error)
							$(messageHolder).removeClass('hidden')
								.addClass('alert alert-danger')
								.html(response.error);

						if (response.success)
							$(messageHolder).removeClass('hidden')
								.addClass('alert alert-success')
								.html(response.success);
					}
				});
			}

			return false;
		});
	}

	if (is_Android) {
		try {
			Android.closeWindow();
		} catch (error) {
		}
	} else if (is_iOSwebview) {
		window.location.hash = 'iosClosewindow';
	}

	try {
		const _trigger_params = ['src', 'utm_source', 'utm_medium', 'utm_campaign'];
		let _contains_trigger = false;
		const _active_days = 30;
		for (let __i = _trigger_params.length - 1; __i >= 0; --__i) {
			if (window.location.href.indexOf(_trigger_params[__i]) !== -1) {
				_contains_trigger = true;
			}
		}
		if (STORE.user_is_logged_in) {
			if (readCookie('DCM3new')) {
				eraseCookie('DCM3new');
			}
			if (!readCookie('DCM3exist')) {
				createCookie('DCM3exist', 'active', _active_days);
			}
		}
		if (!readCookie('DCM3exist')) {
			if (readCookie('DCM3new')) {
				const _existing_val = readCookie('DCM3new');
				const _new_val = parseInt(_existing_val) + 1;
				if (_new_val >= 3) {
					dataLayerPush({'event': 'dcmCustomer3Pages'});
					createCookie('DCM3exist', 'active', _active_days);
				} else {
					createCookie('DCM3new', _new_val, _active_days);
				}
			} else {
				if (_contains_trigger) {
					createCookie('DCM3new', 1, _active_days);
				}
			}
		}
	} catch (error) {
		console.log('DCM 3 page error: ', error);
	}

	const toggleButton = document.querySelector('#consent-options');
	if (toggleButton && document.querySelector('.new-footer-overlay')) {
		const mainButtons = toggleButton.parentElement.querySelector('.main-buttons');
		const buttonGroups = mainButtons.querySelectorAll('.buttons-group');

		const observer = new MutationObserver((mutations) => {
			mutations.forEach(function (mutation) {
				if (mutation.attributeName === 'aria-expanded') {
					if (toggleButton.getAttribute('aria-expanded') === 'true') {
						buttonGroups.forEach((element) => {
							mainButtons.classList.add('hide-space-on-mobile');
							element.classList.add('hide-buttons-group');
						});
					} else {
						buttonGroups.forEach((element) => {
							mainButtons.classList.remove('hide-space-on-mobile');
							element.classList.remove('hide-buttons-group');
						});
					}
				}
			});
		});

		observer.observe(toggleButton, { attributes: true });
	}
});

function submitForm(action, fields = []) {
	const form = document.createElement('form');
	form.action = action;
	form.method = 'post';

	const form_security_fields = get_form_security_fields();
	for (let name in form_security_fields) {
		const field = document.createElement('input');
		field.type = 'hidden';
		field.name = name;
		field.value = form_security_fields[name];
		form.appendChild(field);
	}

	fields.forEach(field => {
		const i_field = document.createElement('input');
		i_field.type = field.type;
		i_field.name = field.name;
		i_field.value = field.value;
		form.appendChild(i_field);
	});

	document.querySelector('body').appendChild(form);
	form.submit();
}

/**
 * Returns the CC type
 *
 * @param {string}   val      CC number
 *
 * @return {string}  If matched, returns the CC type
 */
function cardType(val) {
	let _type = '';
	if (val && val.length > 1) {
		if (val.match(/^2[2-7]/) || val.match(/^5[1-5]/)) {
			_type = 'mastercard';
		} else if (val.match(/^3[47]/)) {
			_type = 'american_express';
		} else if (val.match(/^6(011|4[4-9]|5)/)) {
			_type = 'discover';
		} else if (val.match(/^(2131|1800|35)/)) {
			_type = 'jcb';
		} else if (val.match(/^4/)) {
			_type = 'visa';
		}
	}

	return _type;
}

function updateBroadbandCardDetails(pack, element_id = 'broadband_details') {
	try {
		const content = document.getElementById(element_id);
		if (!content) {
			return;
		}

		const container = content.closest('.broadband_container');
		if (!container) {
			return;
		}


		let display_amount = 0;
		const mobile_data = pack?.pack_products?.reduce((carry, product) => {
			if (product.product_data.display_amount) {
				display_amount = product.product_data.display_amount;
			}

			return product.type === 'mobile_data' ? product : carry;
		}, null);

		if (!mobile_data) {
			container.classList.add('disabled');
			$(content).collapse('hide');
			return;
		}

		container.classList.remove('disabled');

		const plan_price_max_discount = parseFloat(pack?.max_discount);
		const is_promo = plan_price_max_discount > 0;
		const plan_price = is_promo ? parseFloat(pack?.price - plan_price_max_discount) : parseFloat(pack?.price);
		const plan_recurring_price = pack?.recurring_product ? parseFloat(pack?.recurring_product.price) : 0;
		const mobile_data_amount = mobile_data ? mobile_data['translated_name'] : '';
		const has_unlimited_mobile_data = mobile_data ? mobile_data['product_data']['amount'] === 0 : false;

		content.querySelector('.js-plan-name').innerHTML = pack?.pack_name;
		content.querySelector('.js-plan-price').innerHTML = format_money(plan_price, __currency);
		content.querySelector('.js-fcc-uid').innerHTML = pack?.product_data?.fcc_uid;
		content.querySelector('.js-mobile-data-amount').innerHTML = mobile_data_amount;
		content.querySelector('.js-mobile-data-unlimited').innerHTML = it('FCC_BROADBAND_SECTION_6_INFO_3', {
			display_amount: format_megabyte(display_amount),
		});
		content.querySelector('.js-mobile-data-unlimited').classList.toggle('hidden', !has_unlimited_mobile_data);
		content.querySelector('.js-mobile-data-amount').classList.toggle('hidden', has_unlimited_mobile_data);

		const promo_container = content.querySelector('.js-broadband-promo');
		const non_promo_container = content.querySelector('.js-broadband-normal');

		if (is_promo) {
			promo_container.querySelector('.js-promo-real-price').innerHTML = format_money(plan_recurring_price, __currency);
			promo_container.classList.remove('hidden');
			non_promo_container.classList.add('hidden');
		} else {
			promo_container.classList.add('hidden');
			non_promo_container.classList.remove('hidden');
		}
	} catch (e) {
		console.error(`Error updating broadband card details: ${e.message}`);
	}
}
